import {React, useState} from 'react';
import {Link} from 'react-router-dom';
import {Grid, Box, Button, Paper,createTheme, ThemeProvider, Typography} from '@mui/material';
import {PermDataSetting, SettingsApplications, CropRotate, RoomPreferences, Receipt, CurrencyRupee} from '@mui/icons-material';
import { HiOutlineCurrencyRupee } from "react-icons/hi2";
import { FaHandHolding } from "react-icons/fa";

function handleClick(event){
  alert(event.currentTarget.id)
}

function CompanyMasters(){

  const [values, setValues] = useState();
  const [openPopup, setOpenPopup] = useState(false);

  const theme = createTheme({
    palette: {
      primary: { main: '#0b418e' },
      danger: {
        main: '#ffeb3b',
      },
      orange: {
        main: '#ff5722',
      },
      blueGrey: {
        main: '#607d8b',
      },
      lightGreen: {
        main: '#689f38',
      },
      pink: {
        main: '#ec407a',
      },
    },
  });

  return(
    <ThemeProvider theme={theme}>
    <Box className="master-button-container">
      <Paper className="paper-container" elevation={5} sx={{width: "1000px", padding: "30px"}}>
      <Typography variant="h4" sx={{textAlign: "center", marginBottom: "20px"}}>Component Configuration</Typography>

          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="pt-slabs-configure" className="link">
                <Button id="btn5" sx={{color: "white"}} className="master-btn" variant="contained" color="success" startIcon={<PermDataSetting sx={{width: "30px", height: "30px"}}/>}>
                  PT Slabs Configuration
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="pf-rules-configure" className="link">
                <Button id="btn6" sx={{color: "white"}} className="master-btn" variant="contained" color="orange" startIcon={<RoomPreferences sx={{width: "30px", height: "30px"}}/>}>
                  PF Rules Configuration
                </Button>
              </Link>
            </Grid>
          </Grid>

          <Grid container className="master-button-row" spacing={2}>
            <Grid item>
              <Link to="ctc-configure" className="link">
                <Button id="btn7" sx={{color: "white"}} className="master-btn" variant="contained" color="error" startIcon={<SettingsApplications sx={{width: "30px", height: "30px"}}/>}>
                  CTC Configuration
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="esic-configure" className="link">
                <Button id="btn8" sx={{color: "white"}} className="master-btn" variant="contained" color="pink" startIcon={<CropRotate sx={{width: "30px", height: "30px"}}/>}>
                  ESIC Configuration
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="tds-configure" className="link">
                <Button id="btn9" sx={{color: "white"}} className="master-btn" variant="contained" color="blueGrey" startIcon={<HiOutlineCurrencyRupee size={30}/>}>
                  TDS Configuration
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="income-tax-rules-configure" className="link">
                <Button id="btn10" sx={{color: "white"}} className="master-btn" variant="contained" color="lightGreen" startIcon={<Receipt sx={{width: "30px", height: "30px"}}/>}>
                  Income Tax Rules
                </Button>
              </Link>
            </Grid>
            <Grid item>
              <Link to="gratuity-configure" className="link">
                <Button
                  id="btn11"
                  sx={{color: "white"}}
                  className="master-btn"
                  variant="contained"
                  color="primary"
                  startIcon={
                    <Box sx={{ position: 'relative', width: 30, height: 30, display: 'inline-flex' }}>
                      <FaHandHolding size={22} style={{ position: 'absolute', left: 0, bottom: 2 }} />
                      <CurrencyRupee sx={{ fontSize: 14, position: 'absolute', right: 0, top: 0 }} />
                    </Box>
                  }
                >
                  Gratuity Configuration
                </Button>
              </Link>
            </Grid>
          </Grid>



      </Paper>
    </Box>
    </ThemeProvider>
  )
}

export default CompanyMasters;
